import {LOCALE_ID, NgModule, provideZoneChangeDetection} from '@angular/core';
import {BrowserModule, provideClientHydration} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi
} from '@angular/common/http';
import {CommonModule, DatePipe, registerLocaleData} from '@angular/common';
import {provideToastr} from 'ngx-toastr';

import {JWT_OPTIONS, JwtHelperService} from '@auth0/angular-jwt';
import {AuthGuard} from './guard/auth.guard';
import {AuthInterceptor} from './interceptor/auth.interceptor';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {getDutchPaginatorIntl} from './french-paginator-intl';
import {DateAdapter, NativeDateAdapter, provideNativeDateAdapter} from '@angular/material/core';
import {SmartTapDirective} from './directives/smart-tap.directive';
import {CustomTitleStrategy} from './constant/custom-title-strategy';
import {TitleStrategy} from '@angular/router';
import localeFr from '@angular/common/locales/fr';
import {selectableCacheInterceptor} from './interceptor/cache.interceptor';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {THEME_CONFIG} from '../environments/tokens/theme.token';
import {environment} from '../environments/environment';
import {ACTIVE_TENANT} from '../environments/tokens/active-tenant.token';
import {GA_TRACKING_ID} from '../environments/tokens/ga-analytics.token';

registerLocaleData(localeFr, 'fr-FR')

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    SmartTapDirective,
    AppComponent
  ],
  providers: [
    provideZoneChangeDetection({eventCoalescing: true, runCoalescing: true}),
    provideNativeDateAdapter(),
    provideAnimationsAsync(),
    provideClientHydration(),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([selectableCacheInterceptor]), withFetch()),
    provideToastr({
      timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    {provide: DateAdapter, useClass: NativeDateAdapter},
    {provide: LOCALE_ID, useValue: 'fr-FR'},
    {provide: TitleStrategy, useClass: CustomTitleStrategy},
    DatePipe,
    {provide: JWT_OPTIONS, useValue: JWT_OPTIONS},
    JwtHelperService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    AuthGuard,
    {
      provide: MatPaginatorIntl,
      useValue: getDutchPaginatorIntl()
    },
    {
      provide: THEME_CONFIG,
      useValue: environment.theme
    },
    {
      provide: ACTIVE_TENANT,
      useValue: environment.tenant
    },
    {provide: GA_TRACKING_ID, useValue: environment.measurement_id}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
